import React, { useEffect, useState } from "react";
import { MessageType } from "../../constants";
import "../../modal.css";

export default function HealthSinglePlanSelection({ handleSearch, handleSubmit, planList, openModal, selectedPlan, selectPlan, setSelectedInsurer, insurerList, selectedInsurer, SearchInsurer, SearchPlan }) {
    return (

        <div class={`planSelection ${selectedPlan ? "active" : ''}`}>
            <section class="insurer_selection">


                {selectedInsurer ?
                    <div className="planselect">
                        <div className="heading-insuer-selection" >
                            <div className="backbutton" onClick={() => {
                                setSelectedInsurer()
                                SearchInsurer('')
                            }}>{"<"}</div>
                            {" Select Plan Insurer Wise"}
                        </div>
                        <div class="filter">
                            <input type="text" name="searchPlan" value={null} id='searchPlan' placeholder="Search Plan" onChange={(event) => SearchPlan(event.target.value)} />
                        </div>
                        <section>
                            {planList ? planList.map((item) =>
                                <>
                                    {item.supplier_id === selectedInsurer ?
                                        <label class="radio-button-container"  >{item.plan_name}
                                            <input checked={selectedPlan && selectedPlan.plan_id === item.plan_id} type="radio" onChange={(event) => selectPlan(item, event.target.checked)} />
                                            <span class="checkmark"></span>
                                        </label>
                                        : null}
                                </>
                            ) : null}
                        </section>

                    </div>
                    :
                    <div className="insurer_select">
                        <div className="heading-insuer-selection">
                            Select Insurser
                        </div>
                        <div class="filter">
                            <input type="text" id="searchInsurer" value={null} placeholder="Search Insurer" onChange={(event) => SearchInsurer(event.target.value)} />
                        </div>
                        <div class="list_of_insurer">
                            {insurerList ? Object.values(insurerList).sort((a, b) => a.supplier_name.localeCompare(b.supplier_name, undefined, { caseFirst: "upper" })).map((item) =>
                                <div class="logo_insurer" onClick={() => setSelectedInsurer(item.supplier_id)}> <div class="logoimg"><img src={item.ImageUrl} /> </div><p>{item.supplier_name}</p> </div>
                            ) : null}
                        </div>
                    </div>
                }

            </section>
            <div className={`viewDetail-btn-wrapper ${selectedPlan ? "active" : ''}`}>
                <div className="viewDetail-btn" onClick={() => handleSubmit()}> View Plan Details</div>
            </div>
        </div >
    );
}
